<template>
<div class="chapter">
<div class="inner_page">
<h1>On Heroes Hero-Worship</h1>
<h2 class="sigil_not_in_toc">And the Heroic in History</h2>
<h3 class="sigil_not_in_toc">Thomas Carlyle</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?77e266bb